import { buildServices } from './utils/build_services'
import buildParamList from './utils/build_params'
import omitBy from 'lodash.omitby'
import isEmpty from 'lodash.isempty'
import { CONTENT_BACKOFFICE, VIDEO_BACKOFFICE } from '@/services/axios.config'

const services = [
  {
    name: 'listTaxonomies',
    method: 'get',
    url: (params) => `/taxonomy${buildParamList(omitBy(params, isEmpty))}`,
  },
  {
    name: 'assignTaxonomyToLab',
    method: 'post',
    url: (params) => `/taxonomy/labs/${params.labId}/assign`,
    data: (params) => {
      return {
        skill_id: params.skillId,
      }
    },
  },
]

const videoServices = [
  {
    name: 'assignTaxonomyToVideo',
    method: 'post',
    url: (params) => `/taxonomy/videos/${params.videoId}/assign`,
    data: (params) => {
      return {
        skill_id: params.skillId,
      }
    },
  }
]

export const {
  listTaxonomies,
  assignTaxonomyToLab,
} = buildServices(CONTENT_BACKOFFICE, services)

export const {
  assignTaxonomyToVideo,
} = buildServices(VIDEO_BACKOFFICE, videoServices)